import React, { useEffect } from "react";
import * as actions from "../../../../store/actions/index";
import { connect } from "react-redux";
import { string_to_slug } from "../../../../store/utility";
import { withRouter } from "react-router-dom";
import SearchProductsAdmin from "../../../../components/FindProduct/SearchProductsAdmin/SearchProductsAdmin";

const HomeSectionSearchProducts = (props) => {
  let { searchKey, suggestion, sectionId } = props.match.params;

  if (!searchKey || !suggestion) {
    searchKey = props.searchKey;
    suggestion = props.suggestion;
  }
  //   console.log("SectionId", sectionId);

  useEffect(() => {
    try {
      if (string_to_slug(searchKey) !== suggestion) {
        let sug = null;

        if (suggestion != "results") {
          //Incase entered rather than selecting any option then suggesstion becomes "results"

          sug = suggestion.replaceAll("-", " ");
        }

        props.getSearchProducts(searchKey, sug);
        props.fetchHomeSections();
      }
    } catch (err) {}
  }, [searchKey, suggestion]);

  if (!searchKey || !suggestion) {
    return null;
  }
  const handleAddProductToSection = (productId) => {
    props.addProductToSection(sectionId, productId);
  };
  const checkAlreadyAdded = (productId) => {
    try {
      let isAdded = false;
      let homeSections = props.homeSections;
      if (homeSections) {
        let section = homeSections.filter((sec) => sec.id == sectionId)[0];
        if (section) {
          if (section["products"]) {
            return section["products"].includes(productId);
          }
        }
      }
      return isAdded;
    } catch (error) {
      return false;
    }
  };
  const productCardBtnData = [
    {
      // id: "addBtn1",
      name: "Add",
      className: `btn btn-sm btn-success`,
      clicked: handleAddProductToSection,
      isBtnDisabled: checkAlreadyAdded,
    },
  ];
  return (
    <>
      <SearchProductsAdmin
        key={Math.random() * 10000}
        productCardBtnData={productCardBtnData}
      />
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    homeSections: state.homeProducts.homeSections,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    getSearchProducts: (searchKey, suggestion) =>
      dispatch(actions.fecthSearchProducts(searchKey, suggestion)),
    addProductToSection: (sectionId, productId) => {
      dispatch(actions.addProductToSection(sectionId, productId));
    },
    fetchHomeSections: () => dispatch(actions.fetchHomeSections()),
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(HomeSectionSearchProducts));
